import React from 'react';

const ProductsBanner = () => {
  return (
    <div className="about-banner product-banner">
      <div className="container">
        <div className="banner-heading">
          <h1>Our Products</h1>
          <div className="divider-shape"></div>
        </div>
      </div>
    </div>
  );
};

export default ProductsBanner;
